import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  signal,
  viewChild
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ImpersonateUser } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthHttpService } from '@shared/data';
import { isFormValid } from '@shared/utils';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'moxi-impersonate-user',
  imports: [
    FormsModule,

    TranslatePipe,

    // Ant Design
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzModalModule,
    NzIconModule
  ],
  templateUrl: './impersonate-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpersonateUserComponent implements OnInit {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly authService = inject(AuthHttpService);

  openModal = signal(false);

  impersonateUserForm = new FormGroup({
    userId: new FormControl(undefined, {
      validators: [Validators.required, Validators.email],
      updateOn: 'blur'
    })
  });

  ngForm = viewChild<NgForm>('form');

  ngOnInit(): void {
    this.fb.group(this.impersonateUserForm);
  }

  onImpersonateUserSubmit(): void {
    if (isFormValid(this.impersonateUserForm)) {
      const payload = this.impersonateUserForm.getRawValue() as ImpersonateUser;

      this.authService.impersonate(payload);
      this.openModal.set(false);
    }
  }
}
